import { array, boolean, mixed, number, object, SchemaOf, string } from 'yup'

import { validRatings } from '../../../../components/SelectRating'
import { IssuerFormValues } from '../../models'

const isThisBankParticipatingOfABankingGroup = (id: number, belongsToBankingGroup: boolean) =>
  !!id || (!id && belongsToBankingGroup)

const isThisBankingANewBankingGroup = (id: number, belongsToBankingGroup: boolean) =>
  !isThisBankParticipatingOfABankingGroup(id, belongsToBankingGroup)

export const issuerValidationSchema: SchemaOf<IssuerFormValues> = object().shape({
  id: number().nullable(),
  name: string().trim().min(2).required(),
  shortName: string().trim().min(2).required(),
  code: string().trim().min(2).required(),
  frontOfficeEmail: array().of(string().email().required()),
  backOfficeEmail: array().of(string().email().required()),
  leiCode: string().min(2),
  clearCode: string().min(2),
  fundsFossilFuels: boolean(),
  belongsToBankingGroup: boolean(),
  bankingGroupId: mixed().when(['id', 'belongsToBankingGroup'], {
    is: isThisBankParticipatingOfABankingGroup,
    then: number().required(),
    otherwise: mixed().notRequired(),
  }),
  longRating: mixed().when(['id', 'belongsToBankingGroup'], {
    is: isThisBankingANewBankingGroup,
    then: mixed().oneOf(validRatings.long),
    otherwise: mixed().notRequired(),
  }),
  shortRating: mixed().when(['id', 'belongsToBankingGroup'], {
    is: isThisBankingANewBankingGroup,
    then: mixed().oneOf(validRatings.short),
    otherwise: mixed().notRequired(),
  }),
})
